// extracted by mini-css-extract-plugin
export var body = "_2s-1";
export var bodyPadded = "_2s-2";
export var chevron = "_2s-4";
export var chevronOpen = "_2s-5";
export var header = "_2s-0";
export var icon = "_2s-3";